import React, { useEffect, useRef } from "react";

/**
 * Component that renders HTML containing some advanced MathML elements like mlongdiv and ensures MathJax processes it
 */
export const MathMLRenderer = ({ htmlContent }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!htmlContent || !containerRef.current) return;

    const containsMathML = /<math[^>]*>/i.test(htmlContent);
    
    if (containsMathML && typeof window?.MathJax !== "undefined") {
      // Small delay to ensure DOM is updated before MathJax processes it
      const timer = setTimeout(() => {
        try {
          // Tell MathJax to process the specific container
          window.MathJax.typeset([containerRef.current]);
        } catch (error) {
          console.warn('MathJax typeset error:', error);
        }
      }, 10);

      return () => clearTimeout(timer);
    }
  }, [htmlContent]);

  if (!htmlContent) return null;

  // Process MathML linebreaks by converting them to HTML breaks
  const preprocessMathMLLinebreaks = (content) => {
    // Convert mspace linebreak elements to HTML breaks
    return content.replace(
      /<mspace[^>]*linebreak\s*=\s*["']newline["'][^>]*\/?>/gi,
      '</math><br/><math xmlns="http://www.w3.org/1998/Math/MathML">'
    );
  };

  // Process the HTML to remove escaped newlines and handle MathML linebreaks
  const processedHTML = preprocessMathMLLinebreaks(htmlContent.replace(/\\n/g, ''));

  return (
    <div 
      ref={containerRef}
      dangerouslySetInnerHTML={{ __html: processedHTML }} 
    />
  );
};
